import { TSize } from 'src/interfaces/global';
import { addTransition, getSpacing } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNGSpinner = styled.span<{ isActivated?: boolean; spinnerSize: TSize }>`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;

	${(p) => css`
		width: ${getSpacing(p.spinnerSize || 0)};
		height: ${getSpacing(p.spinnerSize || 0)};

		${addTransition()}

		${!p.isActivated ? `opacity: 0; transform: scale(0);` : `opacity: 1;`}

		&::before {
			content: ' ';
			position: absolute;
			top: 20%;
			left: 20%;
			right: 20%;
			bottom: 20%;
			z-index: 2;

			border: 2px solid ${p.theme.colors.lead};
			border-bottom-color: ${p.theme.colors.gold};
			border-right-color: ${p.theme.colors.gold};
			border-radius: 50%;

			animation: spin 1.5s linear infinite;
			will-change: transform;
		}
	`}
`;
